module.exports = __webpack_public_path__ + "img/jiankong.73ed3ae8.jpg";